import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home } from 'lucide-react'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col relative overflow-hidden">
      {/* Content - centered */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center"
        >
          {/* Package emoji animation */}
          <div className="text-6xl mb-4">
            <span className="inline-block">📦</span>
            <span className="inline-block mx-2">→</span>
            <span className="inline-block">💨</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-foreground mb-2">
            Pakken er borte
          </h1>

          {/* Subtitle */}
          <p className="text-lg text-muted-foreground mb-2">
            Oops! Denne pakken ble ikke funnet.
          </p>
          <p className="text-muted-foreground mb-8">
            Kanskje den ble levert til feil adresse?
          </p>

          {/* Back button */}
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-xl transition-colors"
          >
            <Home className="w-5 h-5" />
            Hjem
          </Link>
        </motion.div>
      </div>

      {/* Image in bottom right corner - no margin/padding */}
      <motion.img
        src="/images/404_bare_drite_i.png"
        alt="Hva faen gjor du her!?"
        className="absolute bottom-0 right-0 w-72 sm:w-80 md:w-96 lg:w-[28rem] max-h-[50vh] object-contain object-bottom pointer-events-none"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      />
    </div>
  )
}
